import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ForecastWeekEditable } from '../../services/forecast-week-editable.service';
import { CampaignUpdateReplacement } from '../forecast-week/CampaignUpdate';

@Component({
	selector: 'app-replacement-week',
	templateUrl: './replacement-week.component.html',
	styleUrls: ['./replacement-week.component.scss'],
})
export class ReplacementWeekComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;

	private campaingUpdate: CampaignUpdateReplacement =
		new CampaignUpdateReplacement(0, 0, 0);
	campaignList: any = [];
	campaignTypeList: any = [];
	campaignPeriods: any = [];
	isHidden: boolean = false;
	public selectedCampaign: number;
	public selectedTypeCampaign: string;
	keyword = 'name';
	isSearch: boolean = false;
	fechas: any;
	days: any;

	constructor(private forecastWeekEditable: ForecastWeekEditable) {}

	ngAfterViewInit() {
		const monday_1 = getNextMonday(new Date(), 7).toDateString().slice(4);
		const monday_2 = getNextMonday(new Date(), 14).toDateString().slice(4);
		const monday_3 = getNextMonday(new Date(), 21).toDateString().slice(4);
		const monday_4 = getNextMonday(new Date(), 28).toDateString().slice(4);
		const monday_5 = getNextMonday(new Date(), 35).toDateString().slice(4);
		const monday_6 = getNextMonday(new Date(), 42).toDateString().slice(4);
		const monday_7 = getNextMonday(new Date(), 49).toDateString().slice(4);
		const monday_8 = getNextMonday(new Date(), 56).toDateString().slice(4);

		var promise = Promise.resolve(
			this.forecastWeekEditable.getForecastReplacement(),
		);
		promise.then((value) => {
			var changed = (
				instance: any,
				cell: any,
				x: any,
				y: any,
				value: any,
			) => {
				var cellName = jspreadsheet.getColumnNameFromId([x, y]);
				var rowInt = parseInt(y) + 1;

				var campaignId = tableWeek.getLabel('B' + rowInt);
				var leadsAssigned = value;
				var getDays = x;

				if (x == 5) {
					this.days = 7;
				}
				if (x == 6) {
					this.days = 14;
				}
				if (x == 7) {
					this.days = 21;
				}
				if (x == 8) {
					this.days = 28;
				}
				if (x == 9) {
					this.days = 35;
				}
				if (x == 10) {
					this.days = 42;
				}
				if (x == 11) {
					this.days = 49;
				}
				if (x == 12) {
					this.days = 56;
				}

				if (x > 4 && x < 13) {
					var getDate = getNextMonday(new Date(), this.days);
					var date = formatDate(getDate);
					this.campaingUpdate = new CampaignUpdateReplacement(
						campaignId,
						leadsAssigned,
						date,
					);
					Promise.resolve(
						this.forecastWeekEditable.updateWeekForecastReplacement(
							this.campaingUpdate,
						),
					);
				}
			};

			var tableWeek = jspreadsheet(this.sheet.nativeElement, {
				data: value.body,
				csvHeaders: true,
				search: true,
				pagination: 100,
				tableOverflow: true,
				freezeColumns: 3,
				tableWidth: '1100px',
				tableHeight: '1100px',
				columns: [
					{ title: 'Row', width: 80, type: 'hidden', readOnly: true },
					{
						title: 'Campaign ID',
						width: 80,
						type: 'hidden',
						readOnly: true,
					},
					{ title: 'Campaign', width: 100, readOnly: true },
					{ title: 'Industry', width: 100, readOnly: true },
					{
						title: 'Replacement Cost',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70 },
					{ title: 'Replacement', width: 70, readOnly: true },
					{
						title: 'Income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
				],
				footers: [
					[
						'',
						'',
						'',
						'',
						'Total',
						'=ROUND(SUM(F1:F300),2)',
						'=ROUND(SUM(G1:G300),2)',
						'=ROUND(SUM(H1:H300),2)',
						'=ROUND(SUM(I1:I300),2)',
						'=ROUND(SUM(J1:J300),2)',
						'=ROUND(SUM(K1:K300),2)',
						'=ROUND(SUM(L1:L300),2)',
						'=ROUND(SUM(M1:M300),2)',
						'=ROUND(SUM(N1:N300),2)',
						'=ROUND(SUM(O1:O300),2)',
					],
				],
				onchange: changed,
				nestedHeaders: [
					[
						{
							title: 'Campaign Info',
							colspan: 3,
						},
						{
							title: monday_1,
						},
						{
							title: monday_2,
						},
						{
							title: monday_3,
						},
						{
							title: monday_4,
						},
						{
							title: monday_5,
						},
						{
							title: monday_6,
						},
						{
							title: monday_7,
						},
						{
							title: monday_8,
						},
						{
							title: 'Totals',
							colspan: 2,
						},
					],
				],
				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {
					if (col > 4 && col < 13) {
						if (val == 0) {
							cell.style.backgroundColor = '#fff8b0';
						} else {
							cell.style.backgroundColor = '#edfccf';
						}
					}
				},
			});
		});
	}
}

function getNextMonday(date = new Date(), int: number) {
	const dateCopy = new Date(date.getTime());

	const nextMonday = new Date(
		dateCopy.setDate(
			dateCopy.getDate() + ((int - dateCopy.getDay() + 1) % int || int),
		),
	);

	return nextMonday;
}

function formatDate(fecha: any) {
	var d = new Date(fecha),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [year, month, day].join('-');
}
